import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import ModernNavbarPureCSS from '../../../components/Navbar/ModernNavBarPureCSS';
import Footer from '../../../components/Footer/footer';
import ModernViewJobList from './ModernViewJobList';
import styles from './ModernViewJob.module.css';
import { HardHat } from 'lucide-react';

const ModernViewJob = () => {
  const [username, setUsername] = useState('');
  const [subscription, setSubscription] = useState(false); // Assuming this state is managed elsewhere or passed as a prop

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      setUsername(decodedToken.UserName || 'User');
    }
  }, []);

  const getFirstName = (name) => {
    if (!name || name.toLowerCase() === 'user') return 'User';
    return name.split(' ')[0];
  };

  return (
    <div className={styles.dashboardContainer}>
      <header className={styles.header}>
        <div className={`${styles.container} ${styles.headerContainerFluid}`}>
          <div className={styles.headerContent}>
            <div className={styles.headerLeft}>
              <div className={styles.logoContainer}>
                <HardHat className={styles.logoIcon} />
                <span className={styles.logoText}>Build Start</span>
              </div>
            </div>
          </div>
          <ModernNavbarPureCSS UserName={username} prefix={''} />
        </div>
      </header>

      <main className={`${styles.container} ${styles.mainContent}`}>
        <div className={styles.welcomeSection}>
          <h1 className={styles.welcomeTitle}>View Jobs</h1>
          <p className={styles.welcomeSubtitle}>
            Here are the jobs that match your profile.
          </p>
          {subscription && (
            <a className={styles.subscribeButton} href="/businessdash#subscription-section">
              Subscribe to Job Leads
            </a>
          )}
        </div>
        <ModernViewJobList setSubscription={setSubscription} />
      </main>
      <Footer />
    </div>
  );
};

export default ModernViewJob;
